import React from 'react';
import { styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const PREFIX = 'Desks';

const classes = {
  root: `${PREFIX}-root`,
  chartContainer: `${PREFIX}-chartContainer`,
  chartContainer__title: `${PREFIX}-chartContainer__title`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    fontFamily: 'Roboto, sans-serif',
    display: 'flex',
    flexDirection: 'column',
  },

  [`& .${classes.chartContainer}`]: {
    width: '100%',
    padding: '0 25px 25px 25px',
    marginBottom: theme.spacing(4),
    flexBasis: '50%',
  },

  [`& .${classes.chartContainer__title}`]: {
    height: 45,

    lineHeight: '45px',
    fontSize: 20,
    fontWeight: 'normal',
    color: '#1665D8',
  },
}));

function mapToChartFormat(data) {
  const res = { datasets: [{}] };
  res.labels = data.map(item => item.tag);
  res.datasets[0].data = data.map(item => item.count);
  res.datasets[0].backgroundColor = '#1976D2';

  return res;
}

function timestampToTime(timestamp) {
  let date = new Date(timestamp);

  let hour = ('0' + date.getHours()).slice(-2);
  let minutes = ('0' + date.getMinutes()).slice(-2);

  return hour + ':' + minutes;
}

const Desks = props => {
  const { data, checked } = props;
  const countBadgesByDesk = mapToChartFormat(data.countBadgesByDesk);
  const countVisitorsByDesk = mapToChartFormat(data.countVisitorsByDesk);
  const countVisitorsByTime = mapToChartFormat(data.countVisitorsByTime);
  countVisitorsByTime.labels = countVisitorsByTime.labels.map(timestampToTime);
  const countBadgesByTime = mapToChartFormat(data.countBadgesByTime);
  countBadgesByTime.labels = countBadgesByTime.labels.map(timestampToTime);

  return (
    <Root className={classes.root}>
      <Card className={classes.chartContainer}>
        <Typography className={classes.chartContainer__title} variant='h1'>
          Количество участников, обработанных стойками
        </Typography>
        <Bar
          data={checked ? countBadgesByDesk : countVisitorsByDesk}
          height={100}
          options={{
            indexAxis: 'y',
            plugins: {
              legend: {
                display: false,
              },
            },
            scales: {
              x: {
                beginAtZero: true,
                ticks: {
                  stepSize: 1,
                },
              },
              y: {
                grid: {
                  display: false,
                },
              },
            },
            elements: {
              bar: {
                borderWidth: 0,
              },
            },
            datasets: {
              bar: {
                barThickness: 8,
              },
            },
          }}
        />
      </Card>
      <Card className={classes.chartContainer}>
        <Typography className={classes.chartContainer__title} variant='h1'>
          Поминутная статистика регистраций по всем стойкам
        </Typography>
        <Bar
          data={checked ? countBadgesByTime : countVisitorsByTime}
          height={100}
          options={{
            plugins: {
              legend: {
                display: false,
              },
            },
            scales: {
              x: {
                grid: {
                  display: false,
                },
              },
              y: {
                beginAtZero: true,
                ticks: {
                  stepSize: 1,
                },
                grid: {
                  borderDash: [8, 4],
                },
              },
            },
            elements: {
              bar: {
                borderWidth: 0,
              },
            },
            datasets: {
              bar: {
                barThickness: 13,
              },
            },
          }}
        />
      </Card>
    </Root>
  );
};

export default Desks;
